import produce from "immer";
import { TableCellValue } from "src/requests/table/types";

interface ReturnType {
  handleAdd(): void;
  handleEdit(newVal: TableCellValue, index: number): void;
  handleDelete(index: number): void;
}

const useCellArrayActions = (
  cellValues: number[],
  onChangeCell: (newCellVals: TableCellValue[]) => void
): ReturnType => {
  const handleEdit = (newVal: TableCellValue, index: number): void => {
    const updatedCells = produce(cellValues, (draft) => {
      draft[index] = newVal !== null ? Number(newVal) : -1;
    });
    onChangeCell(updatedCells);
  };

  const handleAdd = (): void => {
    onChangeCell([...cellValues, -1]);
  };

  const handleDelete = (index: number): void => {
    const newValues = cellValues.filter((_, i) => i !== index);
    onChangeCell(newValues);
  };

  return {
    handleAdd,
    handleDelete,
    handleEdit,
  };
};

export default useCellArrayActions;
